"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayDistinct = void 0;
/**
 * unikalne wartości z tablicy
 * @param array tablica do sumowania
 * @param prop zwracane pole z wiersza tablicy
 */
function arrayDistinct(array, prop) {
    const $result = [];
    const $distinct = {};
    if (prop) {
        for (let i = 0; i < array.length; i++) {
            const $v = array[i][prop];
            if ($distinct[$v] === undefined) {
                $result.push($v);
                $distinct[$v] = i;
            }
        }
    }
    else {
        for (let i = 0; i < array.length; i++) {
            if ($distinct[array[i]] === undefined) {
                $result.push(array[i]);
                $distinct[array[i]] = i;
            }
        }
    }
    return $result;
}
exports.arrayDistinct = arrayDistinct;
//# sourceMappingURL=arrayDistinct.js.map